import { request } from "../../apis";
import { getCurrency } from "../../plugins/utils";

const CURRENCY = getCurrency();

export const getOverviewTrans = ({ params }) =>
  request("get", `/${CURRENCY}/agent/dashboard/trans`, { ...params }, true);

export const getSummary = ({ params }) =>
  request("get", `/${CURRENCY}/agent/receive/summary`, { ...params }, true);
